import React, { memo } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import toLower from 'lodash/toLower';
import startCase from 'lodash/startCase';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: 'fit-content',
    },
    avatar: {
        width: 60,
        height: 60,
    },
    name: {
        marginTop: theme.spacing(1),
    },
}));

const Profile = props => {
    const { className, usuario, ...rest } = props;
    const classes = useStyles();

    return (
        <div {...rest} className={clsx(classes.root, className)}>
            <Avatar
                alt={usuario.txMembro}
                className={classes.avatar}
                src={usuario.txFoto}
            />
            <Typography className={classes.name} variant="h4" translate="no">
                {startCase(toLower(usuario?.txMembro?.split(' ', 2)[0]))}
            </Typography>
        </div>
    );
};

Profile.propTypes = {
    className: PropTypes.string,
};

export default memo(Profile);
